module.exports = __webpack_public_path__ + "static/media/2.98331b08.gif";